export default __webpack_public_path__ + "static/robot-e0dcac52096b320fadffce36c65c5ab9.webp";